interface EmptyStateProps {
  title?: string;
  desc?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  title = "未找到相关内容",
  desc = "换个筛选条件或关键词试试吧。",
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className="ri-movie-2-line text-3xl" />
      </span>
      <h3 className="mt-4 text-lg font-semibold text-foreground-900">{title}</h3>
      <p className="mt-2 max-w-md text-sm text-foreground-500">{desc}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
        >
          <i className="ri-refresh-line" />
          {actionLabel}
        </button>
      )}
    </div>
  );
}